export const MAX_IMAGE_BYTES = 10 * 1024 * 1024;

const toBlob = (canvas, type, quality) => new Promise((resolve, reject) => {
  canvas.toBlob(blob => {
    if (blob) resolve(blob);
    else reject(new Error('ساخت فایل تصویر ممکن نشد.'));
  }, type, quality);
});

export function validateImageFile(file) {
  if (!file) return 'فایلی انتخاب نشده است.';
  if (!String(file.type || '').startsWith('image/')) return 'فقط فایل تصویری قابل انتخاب است.';
  if (file.size >= MAX_IMAGE_BYTES) return 'حجم تصویر باید کمتر از ۱۰ مگابایت باشد.';
  return '';
}

// Camera frames are resized before encoding. This keeps uploads quick on
// mobile devices and guarantees the backend never receives a 10MB+ capture.
export async function captureVideoFrame(video) {
  const sourceWidth = video?.videoWidth || 0;
  const sourceHeight = video?.videoHeight || 0;
  if (!sourceWidth || !sourceHeight) throw new Error('تصویر دوربین هنوز آماده نیست.');

  const maxEdge = 2400;
  const scale = Math.min(1, maxEdge / Math.max(sourceWidth, sourceHeight));
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(sourceWidth * scale);
  canvas.height = Math.round(sourceHeight * scale);
  const context = canvas.getContext('2d');
  if (!context) throw new Error('گرفتن عکس در این مرورگر ممکن نیست.');
  context.drawImage(video, 0, 0, canvas.width, canvas.height);

  let quality = 0.9;
  let blob = await toBlob(canvas, 'image/jpeg', quality);
  while (blob.size >= MAX_IMAGE_BYTES && quality > 0.45) {
    quality -= 0.1;
    blob = await toBlob(canvas, 'image/jpeg', quality);
  }
  if (blob.size >= MAX_IMAGE_BYTES) throw new Error('حجم عکس بیشتر از ۱۰ مگابایت است؛ دوباره عکس بگیرید.');

  return new File([blob], `plate-${Date.now()}.jpg`, {
    type: 'image/jpeg',
    lastModified: Date.now(),
  });
}

export function createImageUrl(file) {
  return URL.createObjectURL(file);
}
